"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accuracy = void 0;
var assert_1 = __importDefault(require("assert"));
var Percent_1 = require("./Percent");
var Accuracy = /** @class */ (function () {
    function Accuracy(estimated, actual) {
        this.estimated = estimated;
        this.actual = actual;
        if (estimated < 0) {
            console.log("Accuracy estimated must be positive. Received: ".concat(estimated));
            this.estimated = 0;
        }
        if (actual < 0) {
            console.log("Accuracy actual must be positive. Received: ".concat(actual));
            this.actual = 0;
        }
    }
    Accuracy.createInnaccurate = function () {
        return new Accuracy(1, 0);
    };
    Accuracy.averageOf = function (accuracies) {
        (0, assert_1.default)(accuracies.length > 0, "Can't average no accuracy");
        var percent = Percent_1.Percent.averageOf(accuracies.map(function (accuracy) { return accuracy.percent; }));
        return Accuracy.fromPercent(percent);
    };
    Accuracy.fromPercent = function (percent) {
        return new Accuracy(100, percent.value);
    };
    Accuracy.prototype.withMinimum = function (percent) {
        return Accuracy.fromPercent(this.percent.withMinimum(percent));
    };
    Object.defineProperty(Accuracy.prototype, "percent", {
        get: function () {
            return new Percent_1.Percent(Math.max(100 - this.errorRate.value, 0));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Accuracy.prototype, "errorRate", {
        get: function () {
            return Percent_1.Percent.fromDecimal(Math.abs(this.actual - this.estimated) / this.estimated, { allowOver100: true });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Accuracy.prototype, "relativeDiff", {
        get: function () {
            return this.actual < this.estimated
                ? new Percent_1.Percent(-1 * this.errorRate.value, { allowUnder0: true })
                : this.errorRate;
        },
        enumerable: false,
        configurable: true
    });
    return Accuracy;
}());
exports.Accuracy = Accuracy;
